import React from 'react'
import Page from 'components/CustomComponents/Layout/Page'
import Helmet from 'react-helmet'
import AuthForm from 'components/CustomComponents/Form/AuthForm'
import l8n from 'l8n'

class LoginPage extends React.Component {
  static defaultProps = {
    pathName: l8n.p_login,
    roles: [],
  }

  render() {
    const { match, ...props } = this.props
    return (
      <Page {...props}>
        <Helmet title={l8n.p_login} />
        <AuthForm mode="login"/>
      </Page>
    )
  }
}

export default LoginPage



// WEBPACK FOOTER //
// ./src/pages/LoginPage/index.js